import React from 'react';
import {
    Box,
    Button,
    CheckOutlined,
    DropdownMenu,
    GlobeOutlined,
} from '@landr/maestro';
import { DropdownOptions, useLanguageDropdown } from './useLanguageDropdown';

export const LanguageDropdown: React.FC = () => {
    const { selectedOption, handleLanguageChange } = useLanguageDropdown();

    return (
        <DropdownMenu minWidth="200px">
            <DropdownMenu.Trigger>
                <Button
                    variant="ghost"
                    isDropdown
                    isRounded
                    justifyContent="flex-start"
                    minWidth="200px"
                    icon={GlobeOutlined}
                >
                    {selectedOption.label}
                </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.List>
                {DropdownOptions.map((item) => {
                    const isSelected =
                        selectedOption.language === item.language;

                    return (
                        <DropdownMenu.Item
                            key={`language-dropdown-${item.language}`}
                            isSelected={isSelected}
                            onClick={() => handleLanguageChange(item)}
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Box>{item.label}</Box>
                            {isSelected && <CheckOutlined />}
                        </DropdownMenu.Item>
                    );
                })}
            </DropdownMenu.List>
        </DropdownMenu>
    );
};
